<template>
  <div class="wrapper">
    <div class="content-container">
      <div class="stingy-card">
        <h2>🎲 Poker Paws' Portfolio Beta Calculator 🎲</h2>
        <img src="https://assets.codepen.io/11151897/pokerpawsbeta.png" alt="Poker Paws Image" class="responsive-cat-image" />
        <!-- Poker Paws' Introductory Commentary -->
        <p>Welcome, fellow investors! I'm Poker Paws, here to guide you through the intriguing world of Portfolio Beta. Understanding your portfolio's beta is key to mastering your investment strategy, much like knowing the odds in a game of poker!</p>
       
        <!-- Portfolio Beta Calculator -->
        <div>
          <h3>Calculate Your Portfolio's Beta</h3>
          <p>Enter the stocks that you are holding, their weights in your portfolio (i.e. the percentage out of 100 of those stocks that may up your portfolio), and their respective 1-Year Beta values which you can plug in below and get. Remember, the weight of each stock shows its proportion in your portfolio, influencing how much it affects your overall risk. The 1-Year Beta value measures how volatile each stock is compared to the market – a beta greater than 1 means higher volatility, while less than 1 means lower.</p>
          
          <form @submit.prevent="calculatePortfolioBeta">
            <div v-for="(stock, index) in portfolioStocks" :key="index" class="stock-input">
              <input type="text" v-model="stock.symbol" placeholder="Stock Symbol">
              <input type="number" v-model.number="stock.weight" placeholder="Weight %" min="0" max="100" step="0.01">
              <input type="number" v-model.number="stock.beta" placeholder="1-Year Beta Value" step="0.0001">
              <button type="button" @click="removeStock(index)">Remove</button>
            </div>
            <button type="button" @click="addStock">Add Stock</button>
            <button type="submit">Calculate Portfolio Beta</button>
          </form>
          <div>
            <p>Total Portfolio Weight: {{ totalWeight }}%</p>
            <p v-if="totalWeight !== 100" class="warning">Total weight should be 100%</p>
          </div>
          <div v-if="portfolioBeta !== null">
            <h3>Your Portfolio Beta: {{ portfolioBeta.toFixed(2) }}</h3>
          </div>
        </div>
      </div>

      <!-- TradingView Widget -->
      <div>
        <input class="styled-input" type="text" v-model="tickerSymbol" placeholder="Enter Ticker Symbol (e.g., NASDAQ:AAPL)">
        <button @click="loadTradingViewWidget">Load Financials</button>
        <div class="tradingview-widget-container">
          <div class="tradingview-widget-container__widget"></div>
          <div ref="widgetScriptContainer"></div>
        </div>
      </div>
    </div> 
  </div><br><br><br><br><br><br>
</template>

<script>
export default {
  data() {
    return {
      portfolioStocks: [{ symbol: '', weight: '', beta: '' }],
      portfolioBeta: null,
      tickerSymbol: 'NASDAQ:AAPL',
    };
  },
  computed: {
    totalWeight() {
      return this.portfolioStocks.reduce((sum, stock) => sum + stock.weight, 0);
    }
  },
  methods: {
    addStock() {
      this.portfolioStocks.push({ symbol: '', weight: 0, beta: 0 });
    },
    removeStock(index) {
      this.portfolioStocks.splice(index, 1);
    },
    calculatePortfolioBeta() {
      if (this.totalWeight === 100) {
        let totalWeightedBeta = this.portfolioStocks.reduce((sum, stock) => sum + (stock.beta * stock.weight) / 100, 0);
        this.portfolioBeta = totalWeightedBeta;
      } else {
        this.portfolioBeta = null;
      }
    },
    loadTradingViewWidget() {
  this.$refs.widgetScriptContainer.innerHTML = '';
  const script = document.createElement('script');
  script.type = 'text/javascript';
  script.src = 'https://s3.tradingview.com/external-embedding/embed-widget-financials.js';
  script.async = true;
  script.innerHTML = JSON.stringify({
    "colorTheme": "light",
    "isTransparent": false,
    "largeChartUrl": "",
    "displayMode": "regular",
    // Adjust these based on the container's size or screen width
    "width": "100%", // This might need to be adjusted based on what the API supports
    "height": 830, // Consider dynamic height based on aspect ratio or screen height
    "symbol": this.tickerSymbol,
    "locale": this.locale // Locale is dynamically set
  });
  this.$refs.widgetScriptContainer.appendChild(script);
}
  },
  mounted() {
    this.loadTradingViewWidget();
  }
}
</script>

<style scoped>
/* Add your existing CSS styling here */
.stock-input {
  margin-bottom: 10px;
  border-radius: 10px;
}

.tradingview-widget-container {
  border-radius: 10px;
}
button {
  background-color: #4A148C; /* Purple background */
  color: white; /* White text */
  border: none;
  border-radius: 20px; /* Rounded corners */
  padding: 10px 20px; /* Padding inside the button */
  cursor: pointer; /* Cursor style */
  transition: background-color 0.3s ease; /* Smooth transition for hover effect */
}

button:hover {
  background-color: black; /* Black background on hover */
}
.styled-input {
  margin: 5px 0;
  padding: 8px;
  border-radius: 5px;
  border: 1px solid #ccc;
  width: 20%;
  
}

.styled-select option {
  padding: 8px;
  background-color: white;
  color: black;
  
}

/* Optional: style for hover effect on options */
.styled-select option:hover {
  background-color: #f2f2f2;
}
/* Add any additional styles needed for the input fields and other elements */
.stock-input input {
  margin: 5px 0; /* Spacing for inputs */
  padding: 10px; /* Padding for inputs */
  border-radius: 10px; /* Rounded corners for inputs */
  border: 1px solid #ccc; /* Border for inputs */
  
}
.wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  }
  
  .content-container {
  background-color: #4A148C ;  /* Light orange color */
  color: black;
  padding: 20px;
  border-radius: 20px;  /* Adjust this value to your preference */
  overflow: hidden; 
  }
  .stingy-card {
  flex: 1;  /* Take up equal width as the iframe */
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  background-color: white
  }

.warning {
  color: #4A148C;
}

.responsive-cat-image {
  max-width: 100%; /* Make image width responsive */
  height: auto; /* Maintain aspect ratio */
}

/* Optional: Further adjustments for smaller screens */
@media (max-width: 600px) {
  .responsive-cat-image {
    width: 80%; /* Adjust width as needed for smaller screens */
    height: auto; /* Maintain aspect ratio */
  }
}

.tradingview-widget-container {
  max-width: 100%; /* Ensure it doesn't overflow the screen width */
  height: auto; /* Adjust height as necessary, could be fixed or dynamic */
  overflow: hidden; /* Prevent content from overflowing */
}
</style>
